const convertToCssValue = (val) => (val || val === 0 ? `${val}px` : 'auto');

export default convertToCssValue;
